import React from 'react';
import type { ItemVariant } from 'root/apiTypes';
import { Variant } from 'root/components/Menus/Variant/Variant';
import { classes } from './PriceVariants.st.css';
import { dataHooks } from 'root/dataHooks';
import { usePriceVariantsLogic } from './PriceVariants.logic';

export const PriceVariants = ({ variants }: { variants: ItemVariant[] }) => {
  const { showDivider } = usePriceVariantsLogic();

  return (
    <div className={classes.priceVariants} data-hook={dataHooks.item.priceVariants} role="list">
      {variants.map((variant, index) => (
        <Variant key={variant.id} showDivider={showDivider && index !== variants.length - 1} variant={variant} />
      ))}
    </div>
  );
};
